import Container from 'components/Container'
import Form from 'components/Form'
import * as S from './styles'

const Register = () => (
  <S.Wrapper>
    <Container paddingTop={5}>
      <Form />
    </Container>
  </S.Wrapper>
)

export default Register
